import TranslateIcon from "@mui/icons-material/Translate";
import {
  Chip,
  CircularProgress,
  Grid,
  MenuItem,
  Stack,
  Typography
} from "@mui/material";
import { t } from "i18next";
import { useSelector } from "react-redux";
import { PACKAGE_USAGE_TYPE } from "../../constants/Variables";
import globalStyle from "../../globalStyle";
import CustomDropDown from "../CutomDropDown";
import Label from "../Label";
import TextInput from "../TextInputs";
import { useTranslation } from "react-i18next";

const BasicInformation = ({
  inputValues,
  inputError,
  isLoading,
  allCategories,
  allSubCategories,
  allSubSubCategories,
  handleChangeValues,
  handleTranslateToEnglish,
}) => {
  const { t } = useTranslation(["products", "common"]);
  const { currentLanguage } = useSelector((state) => state.languageReducer);

  return (
    <Grid container spacing={2}>

      {/* Heading for basic information */}
      <Grid item md={12}>
        <Typography fontWeight={600} fontSize={20}>
          {t("basicInformation")}
        </Typography>
      </Grid>

      {/* Package name in Romanian */}
      <Grid item xs={12} md={12}>
        <Label
          labelText={t("packageNameInRomanian")}
          required
          htmlFor={"base-package-name-ro"}
        />
        <TextInput
          id={`base-package-name-ro`}
          styleProps={globalStyle.textField}
          placeholder={t("enterPackageNameInRomanian")}
          required
          name={`name_ro`}
          value={inputValues.name_ro}
          onChange={handleChangeValues}
          inputError={Boolean(inputError.name_ro)}
          helperText={t(inputError.name_ro)}
        />
      </Grid>

      {/* Package name in English */}
      <Grid item xs={12} md={12}>
        <Stack
          mb={"5px"}
          direction={"row"}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <Label
            labelText={t("packageNameInEnglish")}
            required
            htmlFor={"base-package-name-en"}
          />
          <Chip
            label={t("translateToEnglish", { ns: "common" })}
            size="small"
            onClick={() =>
              handleTranslateToEnglish("name_ro", "name_en")
            }
            icon={
              isLoading.translateToEnglish ? (
                <CircularProgress size={16} color="inherit" />
              ) : (
                <TranslateIcon />
              )
            }
            disabled={isLoading.translateToEnglish}
          />
        </Stack>
        <TextInput
          id={`base-package-name-en`}
          styleProps={globalStyle.textField}
          placeholder={t("enterPackageNameInEnglish")}
          required
          name={`name_en`}
          value={inputValues.name_en}
          onChange={handleChangeValues}
          inputError={Boolean(inputError.name_en)}
          helperText={t(inputError.name_en)}
        />
      </Grid>

      {/* Solution type */}
      <Grid item xs={12} md={4}>
        <Label
          labelText={t("solutionType")}
          required
          htmlFor={"base-package-solution-type"}
        />
        <CustomDropDown
          id={"base-package-solution-type"}
          name="solutionType"
          value={inputValues.solutionType}
          onChange={handleChangeValues}
          inputError={Boolean(inputError.solutionType)}
          errorText={t(inputError.solutionType)}
          multiple
        >
          <MenuItem value="" disabled>
            {t("selectSolutionType")}
          </MenuItem>
          {PACKAGE_USAGE_TYPE.map((item, index) => (
            <MenuItem key={index} value={item.value}>
              {item.label[currentLanguage]}
            </MenuItem>
          ))}
        </CustomDropDown>
      </Grid>

      {/* Category */}
      <Grid item xs={12} md={4}>
        <Label
          labelText={t("category")}
          required
          htmlFor={"base-package-category"}
        />
        <CustomDropDown
          id={"base-package-category"}
          name={"category"}
          value={inputValues.category}
          onChange={handleChangeValues}
          inputError={Boolean(inputError.category)}
          errorText={t(inputError.category)}
          sx={{
            "& .MuiSelect-outlined": {
              textTransform: "capitalize",
            },
          }}
        >
          <MenuItem value="" disabled>
            {t("selectCategory")}
          </MenuItem>
          {allCategories.map((item, index) => (
            <MenuItem
              key={index}
              value={item?._id}
              sx={{ textTransform: "capitalize" }}
            >
              {item.name[currentLanguage]}
            </MenuItem>
          ))}
        </CustomDropDown>
      </Grid>

      {/* Sub category */}
      <Grid item xs={12} md={4}>
        <Label
          labelText={t("filterBySubCategory")}
          htmlFor={"base-package-sub-category"}
        />
        <CustomDropDown
          id={"base-package-sub-category"}
          name={"subCategory"}
          value={inputValues.subCategory}
          onChange={handleChangeValues}

          sx={{
            "& .MuiSelect-outlined": {
              textTransform: "capitalize",
            },
          }}
        >
          <MenuItem value="" disabled>
            {t("selectSubCategory")}
          </MenuItem>
          {allSubCategories.map((item, index) => (
            <MenuItem
              key={index}
              value={item?._id}
              sx={{ textTransform: "capitalize" }}
            >
              {item.name[currentLanguage]}
            </MenuItem>
          ))}
        </CustomDropDown>
      </Grid>

      {/* Sub sub category */}
      <Grid item xs={12} md={4}>
        <Label
          labelText={t("filterBySubSubCategory")}
          htmlFor={"base-package-sub-sub-category"}
        />
        <CustomDropDown
          id={"base-package-sub-sub-category"}
          name={"subSubCategory"}
          value={inputValues.subSubCategory}
          onChange={handleChangeValues}
          sx={{
            "& .MuiSelect-outlined": {
              textTransform: "capitalize",
            },
          }}
        >
          <MenuItem value="" disabled>
            {t("selectSubSubCategory")}
          </MenuItem>
          {allSubSubCategories.map((item, index) => (
            <MenuItem
              key={index}
              value={item?._id}
              sx={{ textTransform: "capitalize" }}
            >
              {item.name[currentLanguage]}
            </MenuItem>
          ))}
        </CustomDropDown>
      </Grid>
    </Grid>
  );
};

export default BasicInformation;
